import { b2c } from "../../constants/actionTypes";

const requestGetPlanList = (data) => ({
  type: b2c.REQUEST_GET_PLAN_LIST,
  payload: data,
});

const successGetPlanList = (data) => ({
  type: b2c.SUCCESS_GET_PLAN_LIST,
  payload: data,
});

const errorGetPlanList = (data) => ({
  type: b2c.ERROR_GET_PLAN_LIST,
  payload: data,
});

const resetRetrievePlanList = () => ({
  type: b2c.RESET_RETRIEVE_PLAN_LIST,
});

const requestRetrievePlanList = (data) => ({
  type: b2c.REQUEST_RETRIEVE_PLAN_LIST,
  payload: data,
});

const successRetrievePlanList = (data) => ({
  type: b2c.SUCCESS_RETRIEVE_PLAN_LIST,
  payload: data,
});

const errorRetrievePlanList = (data) => ({
  type: b2c.ERROR_RETRIEVE_PLAN_LIST,
  payload: data,
});

const requestUpdateCatalogB2cPlanMap = (id, data) => ({
  type: b2c.REQUEST_UPDATE_CATALOG_B2C_PLAN_MAP,
  id,
  payload: data,
});

const successUpdateCatalogB2cPlanMap = (data) => ({
  type: b2c.SUCCESS_UPDATE_CATALOG_B2C_PLAN_MAP,
  payload: data,
});

const errorUpdateCatalogB2cPlanMap = (data) => ({
  type: b2c.ERROR_UPDATE_CATALOG_B2C_PLAN_MAP,
  payload: data,
});

const requestSetPlanList = (data) => ({
  type: b2c.REQUEST_SET_PLAN_LIST,
  payload: data,
});

const successSetPlanList = (data) => ({
  type: b2c.SUCCESS_SET_PLAN_LIST,
  payload: data,
});

const errorSetPlanList = (data) => ({
  type: b2c.ERROR_SET_PLAN_LIST,
  payload: data,
});

const requestDeletePlan = (data) => ({
  type: b2c.REQUEST_DELETE_PLAN,
  payload: data,
});

const successDeletePlan = (data) => ({
  type: b2c.SUCCESS_DELETE_PLAN,
  payload: data,
});

const errorDeletePlan = (data) => ({
  type: b2c.ERROR_DELETE_PLAN,
  payload: data,
});

const requestUpdatePlan = (id, data) => ({
  type: b2c.REQUEST_UPDATE_PLAN,
  id,
  payload: data,
});

const successUpdatePlan = (data) => ({
  type: b2c.SUCCESS_UPDATE_PLAN,
  payload: data,
});

const errorUpdatePlan = (data) => ({
  type: b2c.ERROR_UPDATE_PLAN,
  payload: data,
});

const createFreeTrialTemplatePlan = (id, data) => ({
  type: b2c.CREATE_FREE_TRIAL_TEMPLATE,
  id,
  payload: data,
});

const successFreeTrialTemplatePlan = (data) => ({
  type: b2c.SUCCESS_FREE_TRIAL_TEMPLATE,
  payload: data,
});

const errorFreeTrialTemplatePlan = (data) => ({
  type: b2c.ERROR_FREE_TRIAL_TEMPLATE,
  payload: data,
});

const getB2cCatalogsList = (data) => ({
  type: b2c.GET_B2C_CATALOGS_LIST,
  payload: data,
});

const successB2cCatalogsList = (data) => ({
  type: b2c.SUCCESS_B2C_CATALOGS_LIST,
  payload: data,
});

const errorB2cCatalogsList = (data) => ({
  type: b2c.ERROR_B2C_CATALOGS_LIST,
  payload: data,
});

const clearB2cCatalogsList = () => ({
  type: b2c.CLEAR_B2C_CATALOGS_LIST,
});

const retriveB2cCatalogsList = (data) => ({
  type: b2c.RETRIVE_B2C_CATALOG_LIST,
  payload: data,
});

const successRetriveB2cCatalogsList = (data) => ({
  type: b2c.SUCCESS_RETRIVE_B2C_CATALOG_LIST,
  payload: data,
});

const errorRetriveB2cCatalogsList = (data) => ({
  type: b2c.ERROR_RETRIVE_B2C_CATALOG_LIST,
  payload: data,
});

const clearRetriveB2cCatalogsList = () => ({
  type: b2c.CLEAR_RETRIVE_B2C_CATALOG_LIST,
});

const getB2CDashTrendingLabs = (data) => ({
  type: b2c.GET_B2C_TRENDING_LABS,
  payload: data,
});

const successB2CDashTrendingLabs = (data) => ({
  type: b2c.SUCCESS_B2C_TRENDING_LABS,
  payload: data,
});

const errorB2CDashTrendingLabs = (data) => ({
  type: b2c.ERROR_B2C_TRENDING_LABS,
  payload: data,
});

const getB2CLatestPurchases = (data) => ({
  type: b2c.REQUEST_GET_LATEST_PURCHASES,
  payload: data,
});

const successB2CLatestPurchases = (data) => ({
  type: b2c.SUCCESS_GET_LATEST_PURCHASES,
  payload: data,
});

const errorB2CLatestPurchases = (data) => ({
  type: b2c.ERROR_GET_LATEST_PURCHASES,
  payload: data,
});

const getB2CVmLabsList = (data) => ({
  type: b2c.GET_B2C_VM_LABS_LIST,
  payload: data,
});

const successB2CVmLabsList = (data) => ({
  type: b2c.SUCCESS_B2C_VM_LABS_LIST,
  payload: data,
});

const errorB2CVmLabsList = (data) => ({
  type: b2c.ERROR_B2C_VM_LABS_LIST,
  payload: data,
});

const requestAddLabIntoCart = (data) => ({
  type: b2c.REQUEST_ADD_LAB_INTO_CART,
  payload: data,
});

const successAddLabIntoCart = (data) => ({
  type: b2c.SUCCESS_ADD_LAB_INTO_CART,
  payload: data,
});

const errorAddLabIntoCart = (data) => ({
  type: b2c.ERROR_ADD_LAB_INTO_CART,
  payload: data,
});

const clearAddLabIntoCart = () => ({
  type: b2c.CLEAR_ADD_LAB_INTO_CART,
});

const retrieveUserCartDetails = (data) => ({
  type: b2c.RETRIVE_USER_CART_DETAILS,
  payload: data,
});

const successUserCartDetails = (data) => ({
  type: b2c.SUCCESS_USER_CART_DETAILS,
  payload: data,
});

const errorUserCartDetails = (data) => ({
  type: b2c.ERROR_USER_CART_DETAILS,
  payload: data,
});

const requestDeleteItemCart = (data) => ({
  type: b2c.REQUEST_DELETE_ITEM_TO_CART,
  payload: data,
});

const successDeleteItemCart = (data) => ({
  type: b2c.SUCCESS_DELETE_ITEM_TO_CART,
  payload: data,
});

const errorDeleteItemCart = (data) => ({
  type: b2c.ERROR_DELETE_ITEM_TO_CART,
  payload: data,
});

const clearPlanItem = () => ({
  type: b2c.CLEAR_PLAN_ITEM,
});

const requestB2cCheckout = (data) => ({
  type: b2c.REQUEST_B2C_CHECKOUT,
  payload: data,
});

const successB2cCheckout = (data) => ({
  type: b2c.SUCCESS_B2C_CHECKOUT,
  payload: data,
});

const errorB2cCheckout = (data) => ({
  type: b2c.ERROR_B2C_CHECKOUT,
  payload: data,
});

const clearB2cCheckout = () => ({
  type: b2c.CLEAR_B2C_CHECKOUT,
});

const requestPaymentCallback = (data) => ({
  type: b2c.REQUEST_PAYMENT_CALLBACK,
  payload: data,
});

const successPaymentCallback = (data) => ({
  type: b2c.SUCCESS_PAYMENT_CALLBACK,
  payload: data,
});

const errorPaymentCallback = (data) => ({
  type: b2c.ERROR_PAYMENT_CALLBACK,
  payload: data,
});

const clearPaymentCallback = (data) => ({
  type: b2c.CLEAR_PAYMENT_CALLBACK,
});

const requestPaymentReceipt = (data) => ({
  type: b2c.REQUEST_PAYMENT_RECEIPT,
  payload: data,
});

const successPaymentReceipt = (data) => ({
  type: b2c.SUCCESS_PAYMENT_RECEIPT,
  payload: data,
});

const errorPaymentReceipt = (data) => ({
  type: b2c.ERROR_PAYMENT_RECEIPT,
  payload: data,
});

const clearPaymentReceipt = () => ({
  type: b2c.CLEAR_PAYMENT_RECEIPT,
});

const clearAddLabCartError = () => ({
  type: b2c.CLEAR_ADD_LAB_INTO_CART_ERROR,
});

const setB2CWebsocketDataList = (data) => ({
  type: b2c.SET_B2C_WEB_SOCKET_DATA,
  data: data,
});

const myLabsB2CLoaderRequest = (data) => ({
  type: b2c.LOADER_B2C_GET_REQUEST,
  data: data,
});

const myLabsB2CLoaderSuccess = (data) => ({
  type: b2c.LOADER_B2C_GET_SUCCESS,
  data: data,
});

const requestApplyDiscount = (id, data) => ({
  type: b2c.REQUEST_APPLY_DISCOUNT,
  id: id,
  payload: data,
});

const successApplyDiscount = (data) => ({
  type: b2c.SUCCESS_APPLY_DISCOUNT,
  payload: data,
});

const errorApplyDiscount = (data) => ({
  type: b2c.ERROR_APPLY_DISCOUNT,
  payload: data,
});

export {
  requestGetPlanList,
  successGetPlanList,
  errorGetPlanList,
  resetRetrievePlanList,
  requestRetrievePlanList,
  successRetrievePlanList,
  errorRetrievePlanList,
  requestUpdateCatalogB2cPlanMap,
  successUpdateCatalogB2cPlanMap,
  errorUpdateCatalogB2cPlanMap,
  requestSetPlanList,
  successSetPlanList,
  errorSetPlanList,
  requestDeletePlan,
  successDeletePlan,
  errorDeletePlan,
  requestUpdatePlan,
  successUpdatePlan,
  errorUpdatePlan,
  createFreeTrialTemplatePlan,
  successFreeTrialTemplatePlan,
  errorFreeTrialTemplatePlan,
  getB2cCatalogsList,
  successB2cCatalogsList,
  errorB2cCatalogsList,
  clearB2cCatalogsList,
  retriveB2cCatalogsList,
  successRetriveB2cCatalogsList,
  errorRetriveB2cCatalogsList,
  clearRetriveB2cCatalogsList,
  getB2CLatestPurchases,
  successB2CLatestPurchases,
  errorB2CLatestPurchases,
  getB2CDashTrendingLabs,
  successB2CDashTrendingLabs,
  errorB2CDashTrendingLabs,
  getB2CVmLabsList,
  successB2CVmLabsList,
  errorB2CVmLabsList,
  requestAddLabIntoCart,
  successAddLabIntoCart,
  errorAddLabIntoCart,
  retrieveUserCartDetails,
  successUserCartDetails,
  errorUserCartDetails,
  clearPlanItem,
  requestDeleteItemCart,
  successDeleteItemCart,
  errorDeleteItemCart,
  clearAddLabIntoCart,
  requestB2cCheckout,
  successB2cCheckout,
  errorB2cCheckout,
  requestPaymentCallback,
  successPaymentCallback,
  errorPaymentCallback,
  requestPaymentReceipt,
  successPaymentReceipt,
  errorPaymentReceipt,
  clearAddLabCartError,
  setB2CWebsocketDataList,
  myLabsB2CLoaderRequest,
  myLabsB2CLoaderSuccess,
  clearPaymentReceipt,
  clearB2cCheckout,
  clearPaymentCallback,
  requestApplyDiscount,
  successApplyDiscount,
  errorApplyDiscount,
};
